export { AuthState, AuthStateInterface } from './auth-state.interface';
